<template>
  <div class="name_popup" v-if="change_name_visible">
    <div class="bg" @click="hideChangeName"></div>
    <div class="pop_up">
      <div class="head">
        <p>Введите ваше имя</p>
        <div class="close" @click="hideChangeName">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47.971 47.971"><path d="M28.228 23.986L47.092 5.122a2.998 2.998 0 0 0 0-4.242 2.998 2.998 0 0 0-4.242 0L23.986 19.744 5.121.88a2.998 2.998 0 0 0-4.242 0 2.998 2.998 0 0 0 0 4.242l18.865 18.864L.879 42.85a2.998 2.998 0 1 0 4.242 4.241l18.865-18.864L42.85 47.091c.586.586 1.354.879 2.121.879s1.535-.293 2.121-.879a2.998 2.998 0 0 0 0-4.242L28.228 23.986z"/></svg>
        </div>
      </div>
      <div class="body">
        <label>
          <p class="field_name">Имя</p>
          <input name="usrFirstName" type="text" v-validate="'required'" v-model="userNames.name" data-vv-validate-on="none">
          <p v-show="errors.has('usrFirstName')" class="field_err">Необходимо ввести имя</p>
        </label>
        <label>
          <p class="field_name">Фамилия</p>
          <input type="text" name="usrLastName" v-model="userNames.surname" v-validate="'required'" data-vv-validate-on="none">
          <p v-show="errors.has('usrLastName')" class="field_err">Необходимо ввести фамилию</p>
        </label>
        <div @click.prevent="saveName" class="save">Сохранить</div>
      </div>
    </div>
    <!-- <div class="body_pop_up">
      <div class="head_section">
        <div class="inner_wrap">
          <p>Введите ваше имя</p>
          <a href="" class="closePopUp" @click.prevent="hideChangeName">
            <img src="../../assets/img/icons/menu_close.svg" alt="close">
          </a>
        </div>
      </div>
      <div class="body_section">
        <div class="inner_wrap">
          <form action="">
            <fieldset>
              <input id="usrName" name="usrFirstName" type="text" v-validate="'required'" v-model="userNames.name" data-vv-validate-on="none">
              <label for="usrName">Имя</label>
              <p v-show="errors.has('usrFirstName')">Необходимо ввести имя</p>
            </fieldset>

            <fieldset>
              <input id="usrSecondName" type="text" name="usrLastName" v-model="userNames.surname" v-validate="'required'" data-vv-validate-on="none">
              <label for="usrSecondName">Фамилия</label>
              <p v-show="errors.has('usrLastName')">Необходимо ввести фамилию</p>
            </fieldset>
            <button type="submit" @click.prevent="saveName">Сохранить</button>
          </form>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
  import Store from '../../store'
  export default {
    data: function () {
      return {
        userNames: {
          name: '',
          surname: ''
        }
      }
    },
    computed: {
      change_name_visible: function () {
        return Store.state.change_name_visible
      }
    },
    methods: {
      hideChangeName: function () {
        Store.commit('hideChangeName')
      },
      saveName: function () {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$http.post('/setuserdata', this.userNames).then(response => {
              if (!response.body.err) {
                Store.commit('updateUserNames', this.userNames)
                this.hideChangeName()
              }
            })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// change-name.vue?11d9af65